import { useAuth } from "@/contexts/AuthContext";
import { ADMIN_ROLES } from "@/lib/roles";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AppShell from "@/components/AppShell";
import BuyerSidebar from "@/components/BuyerSidebar";
import BuyerBottomNav from "@/components/BuyerBottomNav";
import AdminSidebar from "@/components/AdminSidebar";
import AdvisorSidebar from "@/components/AdvisorSidebar";

/**
 * Shell for pages shared across roles (profile, favorites, listing detail,
 * etc.). It picks the correct sidebar for the current user's role so these
 * pages stay consistent with the role-prefixed pages instead of falling back to
 * a bare navigation layout. Sellers and logged-out visitors (who have no
 * sidebar) keep the plain navigation + content + footer layout.
 */
export default function RoleShell({ children }: { children: React.ReactNode }) {
  const { hasRole } = useAuth();

  if (hasRole(...ADMIN_ROLES)) return <AppShell sidebar={<AdminSidebar />}>{children}</AppShell>;
  if (hasRole("bl_advisor")) return <AppShell sidebar={<AdvisorSidebar />}>{children}</AppShell>;
  if (hasRole("buyer")) {
    return (
      <AppShell sidebar={<BuyerSidebar />}>
        {children}
        <BuyerBottomNav />
      </AppShell>
    );
  }

  return (
    <>
      <Navigation />
      {children}
      <Footer />
    </>
  );
}
